import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { UserAccount } from '../../../domain/userAccount';
import { Group } from '../../../domain/group';
import { usePermissions } from '../../../components/auth/usePermissions';
import { Permission } from '../../../domain/permissions';

type UserGroupsModalProps = {
    show: boolean;
    onClose: () => void;
    onSave: (userSub: string, groupIds: string[]) => Promise<void>;
    user?: UserAccount;
    allGroups: Group[];
}

export const UserGroupsModal = ({ show, onClose, onSave, user, allGroups }: UserGroupsModalProps) => {
    const [selectedGroupIds, setSelectedGroupIds] = useState<string[]>([]);
    const { hasPermission } = usePermissions();


    useEffect(() => {
        if (user) {
            setSelectedGroupIds(user.groupIds || []);
        } else {
            setSelectedGroupIds([]);
        }
    }, [user, show]);

    const handleGroupToggle = (groupId: string) => {
        if (selectedGroupIds.includes(groupId)) {
            setSelectedGroupIds(selectedGroupIds.filter(id => id !== groupId));
        } else {
            setSelectedGroupIds([...selectedGroupIds, groupId]);
        }
    };

    const handleSave = async () => {
        if (user) {
            await onSave(user.sub, selectedGroupIds);
            onClose();
        }
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Zarządzaj grupami użytkownika</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {user && <p>Użytkownik: <strong>{user.firstName} {user.lastname}</strong> ({user.email})</p>}
                <Form>
                    <Form.Label>Wybierz grupy</Form.Label>
                    {allGroups.map((group) => {
                        const isAdministrative = group.permissions.includes(Permission.ADMIN_MANAGE_USERS) ||
                            group.permissions.includes(Permission.ADMIN_MANAGE_GROUPS) ||
                            group.permissions.includes(Permission.OWNER_ASSIGN_ADMIN);
                        const isDisabled = isAdministrative && !hasPermission(Permission.OWNER_ASSIGN_ADMIN);

                        return (
                            <Form.Check
                                key={group.id}
                                type="checkbox"
                                id={`group-${group.id}`}
                                label={group.name}
                                checked={selectedGroupIds.includes(group.id)}
                                onChange={() => handleGroupToggle(group.id)}
                                className="mb-2"
                                disabled={isDisabled}
                            />
                        );
                    })}
                    {allGroups.length === 0 && <p className="text-muted">Brak zdefiniowanych grup.</p>}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Anuluj</Button>
                <Button variant="primary" onClick={handleSave} disabled={!user}>Zapisz</Button>
            </Modal.Footer>
        </Modal>
    );
};
